import {
  GET_STATUS_ORDERS,
  FETCH_STATUS_ORDER,
  ADD_STATUS_ORDER,
  EDIT_STATUS_ORDER,
  DELETE_STATUS_ORDER,
  STATUS_ORDERS_STATISTICS,
  GET_STATUS_ORDERS_BY_TABLE,
  UPDATE_STATUS_ORDER_PAGE_NUMBER,
  UPDATE_STATUS_ORDER_QUERY_PARAMS,
  STATUS_ORDERS_PENDING,
  CLEAR_STATUS_ORDERS,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  status_orders: [],
  status_order: null,
  status_order_statistics: null,
  status_orders_by_table: {},
  pending: false,
  pageNumber: 1,
  queryParams: "",
  total: 0,
  message: null,
  error: null,
};

export default function ActionPlanningStatusReducer(state = initialState, action) {
  switch (action.type) {
    case STATUS_ORDERS_PENDING:
      return {
        ...state,
        pending: true,
      };

    // ==================== GET ALL STATUS ORDERS ====================
    case GET_STATUS_ORDERS:
      return {
        ...state,
        status_orders: action.payload?.results || action.payload || [],
        total: action.payload?.count || 0,
        pending: false,
      };

    // ==================== FETCH SINGLE STATUS ORDER ====================
    case FETCH_STATUS_ORDER:
      return {
        ...state,
        status_order: action.payload,
        pending: false,
      };

    // ==================== ADD STATUS ORDER ====================
    case ADD_STATUS_ORDER:
      return {
        ...state,
        status_orders: [action.payload, ...state.status_orders],
        total: state.total + 1,
        pending: false,
        message: "Status order created successfully",
      };

    // ==================== EDIT STATUS ORDER ====================
    case EDIT_STATUS_ORDER:
      return {
        ...state,
        status_orders: state.status_orders.map((order) =>
          order.id === action.payload.id ? action.payload : order
        ),
        status_order: action.payload.id === state.status_order?.id 
          ? action.payload 
          : state.status_order,
        pending: false,
        message: "Status order updated successfully",
      };

    // ==================== DELETE STATUS ORDER ====================
    case DELETE_STATUS_ORDER:
      return {
        ...state,
        status_orders: state.status_orders.filter(
          (order) => order.id !== action.payload.id
        ),
        total: state.total - 1,
        pending: false,
        message: "Status order deleted successfully",
      };

    // ==================== STATISTICS ====================
    case STATUS_ORDERS_STATISTICS:
      return {
        ...state,
        status_order_statistics: action.payload,
        pending: false,
      };

    // ==================== GET BY TABLE ====================
    case GET_STATUS_ORDERS_BY_TABLE:
      return {
        ...state,
        status_orders_by_table: {
          ...state.status_orders_by_table,
          [action.payload.table_name]: action.payload.data,
        },
        pending: false,
      };

    // ==================== PAGINATION & FILTERS ====================
    case UPDATE_STATUS_ORDER_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };

    case UPDATE_STATUS_ORDER_QUERY_PARAMS:
      return {
        ...state,
        queryParams: action.payload,
      };

    // ==================== CLEAR ====================
    case CLEAR_STATUS_ORDERS:
      return {
        ...initialState,
      };

    case CLEAR_ALL:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
